import { render, staticRenderFns } from "./MultiselectModificationModal.vue?vue&type=template&id=32824e1a"
import script from "./MultiselectModificationModal.vue?vue&type=script&lang=js"
export * from "./MultiselectModificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports